/*global jQuery:false */
var QUEO = window.QUEO || {};

QUEO.Core = (function($){

	var _$html =  $('html'),
        _$w = $(window),
        _mobile,
        _isResizeStart = true,
        _to;

	function _init() {
        _mobile = QUEO.Utils.detectVars.isTouchDevice;

        // Note: atm only burger css "listens" to no-js and it is using $transition-duration-short. Therefore we must use
        // the same delay otherwise animation will run still. If you need no-js for something else with a different
        // timing this should be extended/re-written like using no-animation-short, no-animation-medium, etc.
        setTimeout(function () {
            _$html.removeClass('no-js');
        }, QUEO.Config.transitionDurationShort);

        if (_mobile === false) { 
            _$html.addClass('no-touch');
        }
	}

	// implements custom resize handler (_onResizeStart + _onResizeEnd fired on window) and add state class "is-resizing" on HTML
    _$w.on('resize', function() {

	    if(_isResizeStart) {

	        _isResizeStart = false;

            _$w.trigger('_onResizeStart');

            _$html.addClass('is-resizing');

        }

	    clearTimeout(_to);
        _to = setTimeout(onResizeEnd, 200);

    });
	function onResizeEnd() {

	    _isResizeStart = true;

        _$w.trigger('_onResizeEnd');

	    _$html.removeClass('is-resizing');

    }

	$(_init);

})(jQuery);